import {connect} from 'react-redux';
import axios from 'axios';
import {Alert, Platform} from "react-native"

import LoginEnterPhoneCodeSatiaScreen from '../../../../satia/login/enterMobile/LoginEnterPhoneCodeSatiaScreen';
import {serviceActionSetState} from "../../../splash/action/ActionSplashSatiaScreen";
import * as NavigationService from "../../../../../redux/NavigationService";
import store from "../../../../../redux/store";
import i18n from "../../../../../I18n/i18n";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";
import HMAlert from "../../../../../customviews/HMAlert";
import Toast from "../../../../../customviews/toast";

const mapStateToProps = (state) => ({
    results: state.reducerLoginEnterPhoneCodeSatiaScreen.results,
    NoInternetDialog: state.reducerLoginEnterPhoneCodeSatiaScreen.NoInternetDialog,
    isLoading: state.reducerLoginEnterPhoneCodeSatiaScreen.isLoading,
    isLoadingLogin: state.reducerEnterCodeSatiaScreen.isLoading,


    ConnectionType: state.reducerSplashSatiaScreen.ConnectionType,
    wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
    wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,
    ConnectionInternetHotspot: state.reducerSplashSatiaScreen.ConnectionInternetHotspot,

    DataSplashScreen: state.reducerSplashSatiaScreen,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, stateData, funcRetryCode) => dispatch(callWebservice(getState, url, params, type, typeConnection, stateData, funcRetryCode)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),
    callServiceError: (data) => dispatch(serviceActionError(data)),
    callServiceRefresh: () => dispatch(serviceActionRefresh()),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode) => {
    // let checkTypeLogin = getState.route.params && getState.route.params.type == "forgot_my_password";
    dispatch(serviceActionPending());

    const formData = new FormData();
    //   formData.append('_operation', params._operation);
    //  formData.append('mode', params.mode);
    // formData.append('forgotmode', params.forgotmode);

    formData.append('username', params.mobile);
    formData.append('type', params.type);
    formData.append('retry', params.retry);

    if (params.HashCode)
        formData.append('HashCode', params.HashCode + "");

    Tools.DeviceInfo(formData);


    //  let _abis=null;
    // DeviceInfo.supportedAbis().then(abis => {
    //
    //     _abis=abis&&abis.length>0?abis[0];
    //     // [ "arm64 v8", "Intel x86-64h Haswell", "arm64-v8a", "armeabi-v7a", "armeabi" ]
    // });
    // formData.append('DeviceInfo',  JSON.stringify({name:"aaa",abis:_abis,}));

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
            // 'Access-Control-Allow-Origin': '*',
            //  withCredentials: true
        }
    };

    /*  axios(
          {
              //  url: baseUrl + url + params,
              url: url ,
              method: typeConnection,
          //    params: params,
              data:params,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },

          }
      )*/

    axios({
        method: 'post',
        url: typeExport._baseUrlSatia + "user/sendcode",
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
    // axios.post(url, formData, config)
        .then(response => {

            switch (type) {

                case typeExport.TypegetDataLoginEnterPhoneCodeSatiaScreen:

                    Toast.show({
                        // type: 'success | error | info',
                        type: response.data.status ? 'custom_info' : 'custom_error',
                        //  type: data.status ? 'custom_success' : 'custom_error',
                        //  position: 'top | bottom',
                        position: 'top',
                        text1: i18n.t('constant.message'),
                        text2: response.data.status ? response.data.message : "سرور با مشکل مواجه شد لطفا مجدادا تلاش نمایید",
                        visibilityTime: 3000,
                        autoHide: true,
                        //  topOffset: 30,
                        // bottomOffset: 40,
                        onShow: () => {
                        },
                        onHide: () => {
                        }
                    })
                    if (response.data.status) {


                        dispatch(serviceActionSuccess(response.data))
                        // NavigationService.navigateParams('SplashScreen',);
                        if (!funcRetryCode) {
                      /*      NavigationService.navigateParams("EnterCodeSatiaScreen", {
                                //  type: funcRetryCode || global.funcRetryCodeLogin ? "Login_with_activation_code" : (getState.route.params && getState.route.params.type ? getState.route.params.type : ""),
                                type: "",

                                message: response.data.message,
                                Phone: response.data.Phone,
                                Email: response.data.Email,
                                time: response.data.time,
                                mobile: params.mobile,
                                result_extra: response.data,
                            });*/
                        }
                        else {
                            funcRetryCode()
                        }
                    } else {
                        dispatch(serviceActionRefresh())
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'),
                                    onPress: () => {


                                    }
                                },

                            ],
                            {cancelable: true}
                        )
                        //alert(response.data.error.message)
                    }

                    break;


                default:
            }
        }).catch((e) => {
        Toast.show({
            // type: 'success | error | info',
            type: 'custom_error',
            //  type: data.status ? 'custom_success' : 'custom_error',
            //  position: 'top | bottom',
            position: 'top',
            text1: i18n.t('constant.message'),
            text2: "سرور با مشکل مواجه شد لطفا مجدادا تلاش نمایید",
            visibilityTime: 3000,
            autoHide: true,
            //  topOffset: 30,
            // bottomOffset: 40,
            onShow: () => {
            },
            onHide: () => {
            }
        })
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, stateData, funcRetryCode) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection,stateData);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )


        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, stateData, funcRetryCode);
        } else {
            dispatch(serviceActionError("No Internet Connection"));

        }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.LoginEnterPhoneCodeSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.LoginEnterPhoneCodeSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.LoginEnterPhoneCodeSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.LoginEnterPhoneCodeSatiaScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginEnterPhoneCodeSatiaScreen);
